<div>
  <div *ngIf="reviewFromGuest?.submitted; else noGuestReview" class="guest-review">
    <ng-template
      [ngTemplateOutlet]="review"
      [ngTemplateOutletContext]="{ review: reviewFromGuest, reviewer: 'guest' }"
    ></ng-template>

    <div *ngIf="isRespondable" class="reply-guest-review px-4 pb-4">
      <form [formGroup]="replyForm">
        <mat-form-field2 class="d-block">
          <textarea
            matInput
            placeholder="Response"
            formControlName="message"
            required
            rows="4"
            cdkTextareaAutosize
          ></textarea>
        </mat-form-field2>
        <div class="d-flex align-items-center gap-3">
          <app-select-search
            [items]="templates$ | async"
            (valueChange)="onResponseTemplateChange($event)"
            [hasBlank]="true"
            [multiple]="false"
            bindLabel="name"
            placeholder="Select a Template"
            i18n-placeholder
            [inline]="true"
            style="width: 16rem"
          ></app-select-search>
          <button class="btn btn-secondary-info" [disabled]="isLoading" (click)="onReply(replyForm)">
            <i class="fa fa-reply"></i> Reply
          </button>
          <button
            class="btn btn-secondary-primary"
            (click)="onAIResponse()"
            [disabled]="isLoading || isGeneratingAIresponse"
            *ngIf="(aiResponderSub$ | async)?.isValid"
            matTooltip="Use AI to generate response for this review"
            i18n-matTooltip
          >
            <i class="far fa-spin fa-spinner" *ngIf="isGeneratingAIresponse"></i>
            <i class="cs-icon cs-icon-ai" *ngIf="!isGeneratingAIresponse"></i>
            <ng-container i18n>Generate with AI</ng-container>
          </button>
        </div>
      </form>
    </div>
  </div>
  <ng-template #noGuestReview>
    <app-empty-table>
      <img src="/assets/images/empty_icons/booking-review.svg" alt="" />
      <h6 i18n>No Guest Reviews Yet</h6>
      <p i18n>
        You haven’t received any reviews from your guests for this rental. Keep delivering great stays — reviews will
        appear here once submitted.
      </p>
    </app-empty-table>
  </ng-template>

  <div *ngIf="reviewToGuest?.submitted" class="host-review">
    <ng-template
      [ngTemplateOutlet]="review"
      [ngTemplateOutletContext]="{ review: reviewToGuest, reviewer: 'host' }"
    ></ng-template>
  </div>
</div>

<ng-template #review let-review="review" let-reviewer="reviewer">
  <div
    class="d-flex py-3 px-4 review-header"
    [ngClass]="{ 'border-bottom': reviewer === 'guest', 'border-top': reviewer === 'host' }"
  >
    <div *ngIf="reviewer === 'guest'" style="min-width: 350px">
      <h6>Guest Review from Booking.com</h6>
      <div class="d-flex align-items-center">
        <div style="font-size: 2.5rem" class="mr-2">{{ review.channelOverallRating }}</div>
        <div>
          <app-rating [maxRating]="10" [rating]="review.channelOverallRating" style="font-size: 1.25rem"></app-rating>
        </div>
      </div>
    </div>

    <div *ngIf="reviewer === 'host'" style="min-width: 350px">
      <h6>Review to Guest</h6>
      <div class="d-flex align-items-center" *ngIf="review.isRevieweeRecommended">
        <div style="font-size: 2.5rem" class="mr-2">
          <i class="fas fa-thumbs-up" style="color: #fda333"></i>
        </div>
        <div>
          <div>Recommended</div>
          <div class="text-small text-secondary">
            <span *ngIf="review.response?.respondedAt" class="mr-2"
              >Responded: {{ review.response?.respondedAt | date }}</span
            >
            <span *ngIf="!review.isEligibleForResponse">Expired: {{ review.reviewerCanSubmitUntil | date }}</span>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center" *ngIf="review.isRevieweeRecommended === false">
        <div style="font-size: 2.5rem" class="mr-2">
          <i class="fas fa-thumbs-down" style="color: #799ba5"></i>
        </div>
        <div>
          <div>Not Recommended</div>
          <div class="text-small text-secondary">
            <span *ngIf="review.response?.respondedAt" class="mr-2"
              >Responded: {{ review.response?.respondedAt | date }}</span
            >
            <span *ngIf="!review.isEligibleForResponse">Expired: {{ review.reviewerCanSubmitUntil | date }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="text-small flex-fill">
      <div class="mt-1">
        <div class="text-secondary" i18n>Public Review</div>
        <div>{{ review.text }}</div>
      </div>
      <div class="mt-2" *ngIf="review.positiveText">
        <div class="text-secondary" i18n>Positive Feedback</div>
        <div>{{ review.positiveText }}</div>
      </div>
      <div class="mt-2" *ngIf="review.negativeText">
        <div class="text-secondary" i18n>Negative Feedback</div>
        <div>{{ review.negativeText }}</div>
      </div>
      <div class="mt-2" *ngIf="review.privateFeedback">
        <div class="text-secondary" i18n>Private Feedback</div>
        <div>{{ review.privateFeedback }}</div>
      </div>
    </div>
  </div>
  <div class="category-reviews p-4">
    <ng-container *ngFor="let item of review.categoryRatings">
      <ng-template [ngTemplateOutlet]="categoryReview" [ngTemplateOutletContext]="{ item: item }"></ng-template>
    </ng-container>
  </div>
  <div *ngIf="review.response as response" class="px-4 pb-4 text-small review-response">
    <div class="text-secondary" *ngIf="reviewer === 'guest'" i18n>Response from PM</div>
    <div class="text-secondary" *ngIf="reviewer === 'host'" i18n>Response from Guest</div>
    <div>{{ response.text }}</div>
  </div>
</ng-template>

<ng-template #categoryReview let-item="item">
  <div class="category-review-item">
    <div class="d-flex justify-content-between">
      <div class="text-bold category-title">{{ item.category | titleCase }}</div>
      <app-rating [maxRating]="10" [rating]="item.channelRating"></app-rating>
    </div>
    <div class="flex-fill"></div>
  </div>
</ng-template>
